import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { SimpleModal } from '@livable/saas-react-components';
import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChangePassword } from 'src/components/settings/ChangePassword';
export const ChangePasswordModal = observer(() => {
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  const trigger = /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    'custom-attribute': '306-change-password'
  }, t('general.change_password'));
  return /*#__PURE__*/React.createElement(SimpleModal, {
    handleClose: () => setIsOpen(false),
    handleOpen: () => setIsOpen(true),
    isOpen: isOpen,
    noFooter: true,
    title: t('general.change_password'),
    trigger: trigger
  }, /*#__PURE__*/React.createElement(ChangePassword, {
    onSuccess: () => setIsOpen(false)
  }));
});